/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HelmPermission {
    HELM_USER_READ = 'helm.user.read',
    HELM_USER_WRITE = 'helm.user.write',
    HELM_USER_BOTS = 'helm.user.bots',
    HELM_ROLE_WRITE = 'helm.role.write',
    HELM_ORGANIZATION_READ = 'helm.organization.read',
    HELM_ORGANIZATION_WRITE = 'helm.organization.write',
    HELM_ORGANIZATION_WRITE_OVERRIDE = 'helm.organization.write-override',
    HELM_FEATURE_READ = 'helm.feature.read',
    HELM_FEATURE_WRITE = 'helm.feature.write',
    HELM_FEATURE_DELETE = 'helm.feature.delete',
    HELM_FEATURE_BULK = 'helm.feature.bulk',
    HELM_CONFIG = 'helm.config',
    HELM_HORIZON = 'helm.horizon',
    HELM_MESSAGE_TEMPLATE_WRITE = 'helm.message_template.write',
    HELM_ORGANIZATION_ENTER = 'helm.organization.enter',
    HELM_ORGANIZATION_IMPERSONATE = 'helm.organization.impersonate',
    HELM_DEBUG = 'helm.debug',
    HELM_API_APP_WRITE = 'helm.api_app.write',
    HELM_API_APP_APPROVE = 'helm.api_app.approve',
    HELM_NAVIGATION = 'helm.navigation',
    HELM_IP_ALLOWLIST_READ = 'helm.ip_allowlist.read',
    HELM_IP_ALLOWLIST_WRITE = 'helm.ip_allowlist.write',
    HELM_EMAIL_SUPPRESSION_READ = 'helm.email_suppression.read',
    HELM_EMAIL_SUPPRESSION_WRITE = 'helm.email_suppression.write',
    HELM_SMS_BLACKLIST_READ = 'helm.sms_blacklist.read',
    HELM_SMS_BLACKLIST_WRITE = 'helm.sms_blacklist.write',
    HELM_SQL_EXPORT = 'helm.sql_export',
    HELM_SMS_SETTINGS = 'helm.sms_settings',
    HELM_EMAIL_SETTINGS = 'helm.email_settings',
    HELM_GIVING_SETTINGS = 'helm.giving_settings'
}
